module.exports = __webpack_public_path__ + "img/betsize_btn.ff3f1dde.png";